//TODO: the alert should be shown on a frontend as a string that should always be set to 3 types on the backend "error", "warning", "info"
//We should define how these values are shown on the frontend in different cases
//This approach will allow us to have a flexible way of defining values shown to the user and lets us reuse this component easily throught the app
import ErrorIcon from "@mui/icons-material/Error";
import InfoIcon from "@mui/icons-material/Info";
import WarningIcon from "@mui/icons-material/Warning";
import { Alert } from "@mui/material";
import { nonOverflowingTitleSx } from "../../../../enums/Styles";

export default function AlertBar({ key, severity = "", message = "" }) {
  const pulsateStyle = {
    "@keyframes pulsate": {
      "0%": { transform: "scale(1)", opacity: 1 },
      "50%": { transform: "scale(1.15)", opacity: 0.7 },
      "100%": { transform: "scale(1)", opacity: 1 },
    },
    animation: "pulsate 2.5s infinite ease-in-out",
  };

  const getAlertIcon = (status) => {
    switch (String(status).toLowerCase()) {
      case "error":
        return <ErrorIcon color="error" sx={pulsateStyle} />;
      case "warning":
        return <WarningIcon color="warning" />;
      default:
        return <InfoIcon />;
    }
  };

  const getAlertColor = (status) => {
    switch (String(status).toLowerCase()) {
      case "error":
        return "error";
      case "warning":
        return "warning";
      default:
        return "info";
    }
  };
  return (
    <Alert
      key={key}
      severity={getAlertColor(severity)}
      icon={getAlertIcon(severity)}
      sx={nonOverflowingTitleSx}
    >
      {message}
    </Alert>
  );
}
